import React from 'react';
import PrimarySelect, { PrimarySelectOuterProps } from './PrimarySelect';

export type TypedDropdownOption<T> = {
  id: T;
  name: string;
};

type TypedOuterProps<T> = {
  value: TypedDropdownOption<T>;
  onChange: (value: TypedDropdownOption<T>) => void;
  activeItemClassName?: string;
};

type Props<T> = Omit<PrimarySelectOuterProps, keyof TypedOuterProps<T>> &
  TypedOuterProps<T>;

export const TypedPrimarySelect = <T extends {}>(props: Props<T>) => {
  const { value, onChange, activeItemClassName } = props;
  return (
    <PrimarySelect
      {...props}
      onChange={option => onChange(option as any)}
      value={value as any}
      activeItemClassName={activeItemClassName}
    />
  );
};

type MappedTypedPrimarySelectProps<T extends string> = {
  value: T;
  list: readonly T[];
  captions: Record<T, string>;
  activeItemClassName?: string;
} & Omit<TypedOuterProps<T>, 'value'>;
export const MappedTypedPrimarySelect = <T extends string>(
  props: MappedTypedPrimarySelectProps<T>,
) => {
  const { value, list, captions, activeItemClassName, ...remainingProps } =
    props;
  const mappedValue = {
    id: value,
    name: captions[value],
  };
  const options: TypedDropdownOption<T>[] = list.map(i => ({
    id: i,
    name: captions[i],
  }));
  return (
    <TypedPrimarySelect
      activeItemClassName={activeItemClassName}
      value={mappedValue}
      options={options}
      dropdownWidth="auto"
      {...remainingProps}
    />
  );
};
